import * as THREE from 'three';

export function makeMaterial(color: number, emissive = color, intensity = 0.25): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({ color, emissive, emissiveIntensity: intensity, roughness: 0.57, metalness: 0.6 });
}

export interface EnvironmentMaterialOptions {
  roughness?: number;
  metalness?: number;
  map?: THREE.Texture | null;
  emissive?: number;
  emissiveIntensity?: number;
}

export function makeEnvironmentMaterial(color: number, options: EnvironmentMaterialOptions = {}): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({
    color,
    roughness: options.roughness ?? 0.9,
    metalness: options.metalness ?? 0,
    map: options.map ?? null,
    emissive: options.emissive ?? 0x000000,
    emissiveIntensity: options.emissiveIntensity ?? 0,
  });
}
